export { default } from './WireAmountLabel';
